var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Document-Contract-License--Streamline-Flex.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Document Contract License Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-contract-license--document-contract-license-file-scroll"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 91",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.965114 9.56951C0.653733 10.7159 0.283681 13.25 2.96454 13.25l8.14656 0c-1.92168 0 -2.72931 -1.9823 -2.00521 -3.68049 -2.35077 -0.25934 -5.79 -0.25935 -8.140776 0Z",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.34668 3.91406 4.08552 0",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.34668 6.57031 4.08552 0",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#e5eaf9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.90283 13.249h1.27237c1.0537 0 1.929 -0.8173 1.9772 -1.8698 0.1466 -3.19499 0.1289 -6.37559 -0.0529 -9.57401 -0.0276 -0.4851 -0.4033 -0.877964 -0.8877 -0.916012C9.90829 0.708237 6.82735 0.699343 4.53337 0.888276c-0.46883 0.038613 -0.83669 0.411824 -0.8746 0.880714C3.46324 4.1874 3.48752 6.57359 3.73161 9",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLegal);
export default __webpack_public_path__ + "static/media/dark-legal.4192c5c9f903806a839fb2fb417b0ea2.svg";
export { ForwardRef as ReactComponent };